<template>
  <div class="employeeRoster">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead/></div>
        <div class="screenInputs">
          <div class="screenInput">
            <div>字段名称</div>
            <el-input size="small"></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="text" @click="dialogVisible = true">
          <img src="../../assets/employee/images/add.png" />
        </el-button>
      </div>
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
         <el-breadcrumb-item>花名册字段管理</el-breadcrumb-item>
         <el-breadcrumb-item>自定义管理</el-breadcrumb-item>
       </el-breadcrumb>
      </div>
      <div class="employeeRosterTable">
        <el-table :data="tableData"  :max-height="tableHeight-180"  style="width: 99%">
          <el-table-column align="center" type="selection" width="40px"></el-table-column>
          <el-table-column align="center" label="序号" prop="serialNumber" min-width="10%"></el-table-column>
          <el-table-column  label="字段名称" prop="fieldName" min-width="13%"></el-table-column>
          <el-table-column  label="字段类型" prop="fieldType" min-width="10%"></el-table-column>
          <el-table-column  label="字段关键字" prop="fieldKey" min-width="40%"></el-table-column>
          <el-table-column   label="操作" fixed="right" min-width="20%">
            <template>
              <button class="changeServe" style="margin-right:10px" @click="definitionKey">定义关键字</button>
              <button class="changeState" style="margin-right:10px">修改</button>
              <button class="pinkButton">删除</button>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="100"
            layout="total,prev, pager, next, jumper"
            :total="1000"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <el-dialog :visible.sync="dialogVisible" width="800px" >
        <div class="diaTitle">定义关键字</div>
        <div style="font-size:16px">现有关键字</div>
        <div class="keyWordArea">
          <div v-for="keyWord in keyWords" class="keyWord">{{keyWord}}</div>
        </div>
        <div class="storageArea">
          <div class="textImport">文本导入：</div>
          <div class="storageInput2" style="margin:0 20px 0 0">
            <el-input size="small" v-model="inputValue"></el-input>
          </div>
          <el-upload
            class="upload-demo"
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="success_handle"
            :auto-upload="false"
            :limit="1"
          >
            <el-button slot="trigger" size="small" type="primary" @click="clearFile">浏览</el-button>
          </el-upload>
        </div>
        <div class="enterArea">
          <div class="textImport">手工导入：</div>
           <div>
             <el-input type="textarea" :rows="2" v-model="enterKey"></el-input>
             <div>关键字之间请用逗号隔开</div>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible = false">取消</button>
          <button
            class="search"
            @click="dialogVisible = false"
            style="margin-left:10px;font-weight:600"
          >确定</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableHeight:0,
      //录入内容
      enterKey:"",
      inputValue:"",
      keyWord:"",
      currentPage3:1,
      //定义关键字
      dialogVisible: false,
      keyWords:[
        "现有字段1",
        "现有字段2",
        "现有字段3",
        "现有字段4",
        "现有字段5",
        "现有字段6",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "现有字段1",
        "现有字段2",
        "现有字段3",
        "现有字段4",
        "现有字段5",
        "现有字段6",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "现有字段1",
        "现有字段2",
        "现有字段3",
        "现有字段4",
        "现有字段5",
        "现有字段6",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "现有字段1",
        "现有字段2",
        "现有字段3",
        "现有字段4",
        "现有字段5",
        "现有字段6",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
        "关键字",
      ],
      tableData:[
        {
          serialNumber:1,
          fieldName:"自定义字段名称",
          fieldType:"文本",
          fieldKey:"关键字1，关键字2，关键字3，关键字4，关键字5，关键字6，关键字7"
        }
      ]
    };
  },
  created(){
    this.calHeight();
  },
  methods: {
    handleClick(row) {
      console.log(row);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    
    //定义关键字
    definitionKey(){
      this.dialogVisible = true
    },
     success_handle(response, file, fileList) {
      // this.$refs.upload.clearFiles()
      console.log(response, file, fileList);
      this.inputValue = response.name;
    },
    clearFile(file) {
      this.$refs.upload.clearFiles();
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-right {
  display: flex;
  align-items: center;
  margin-right: 16px;
}
</style>

<style>
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.employeeRosterTable .el-table th>.cell{
  padding: 0;
}
.employeeRosterTable .el-table .cell{
  padding: 0;
}
.employeeRosterTable .el-table td {
  padding: 5px 0;
}
.employeeRosterTable .el-table th {
  padding: 5px 0;
}
.storageInput2 .el-input--small .el-input__inner {
  width: 598px;
  height: 32px;
}
.storageInput2 .el-input--small {
  width: 598px;
}
.storageArea .el-upload-list__item-name {
  display: none;
}
.storageArea .upload-demo {
  height: 32px !important;
}
.storageArea .el-button--primary{
  background-color: #fff;
  color: #000;
  border-color:#ccc;
}
.enterArea .el-textarea__inner{
  width:598px;
  /* margin-left: 6px; */
  margin-bottom: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 10px 20px 0 20px;
}
</style>